var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "input-group", class: [_vm.containerClass, _vm.sizeClass] },
    [
      _c("input", {
        ref: "text",
        staticClass: "form-control",
        attrs: {
          type: "text",
          placeholder: _vm.placeholder,
          title: _vm.toolTip,
          readOnly: _vm.readOnly,
          maxlength: _vm.maxLengthMassaged,
        },
        domProps: { value: _vm.text },
        on: {
          input: function ($event) {
            return _vm.update()
          },
          keyup: function ($event) {
            return _vm.eventGeneric("keyup", $event)
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-group-append" },
        [
          _c(
            "b-dropdown",
            {
              class: [_vm.buttonClass],
              attrs: { text: _vm.currentMatchTypeLabel, right: "" },
            },
            [
              _c(
                "b-dropdown-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.matchTypeUpdate("StartsWith")
                    },
                  },
                },
                [_vm._v("Starts With [SW]")]
              ),
              _vm._v(" "),
              _c(
                "b-dropdown-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.matchTypeUpdate("EndsWith")
                    },
                  },
                },
                [_vm._v("Ends With [EW]")]
              ),
              _vm._v(" "),
              _c(
                "b-dropdown-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.matchTypeUpdate("Contains")
                    },
                  },
                },
                [_vm._v("Contains [CO]")]
              ),
              _vm._v(" "),
              _c(
                "b-dropdown-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.matchTypeUpdate("Equals")
                    },
                  },
                },
                [_vm._v("Equals [EQ]")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }